import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./component/context/AuthContext"
import ProtectedRoute from "./component/nav/ProtectRoute"
import AdminLayout from "./layout/AdminLayout";
import axios from 'axios'
import Login from "./auth/login";
import Dashboard from "./pages/Dashboard";
import StaffList from "./pages/staff/StaffList";
import Sales from "./pages/sales/Sales";
import Attendance from "./pages/attendance/Attendance";
import ProductList from "./pages/product/ProductList";
import Booking from "./pages/booking/Booking";
import AdminStaff from "./pages/AdminStaff";
import Gallery from "./pages/Gallery";
import Clients from "./pages/Clients";
import ServicesManagement from "./pages/ServicesManagement";
import Schedule from "./pages/Schedule";
import WalkIn from "./pages/WalkIn";
import Expenses from "./pages/Expenses";
import Reports from "./pages/Reports";
import NotificationsAudit from "./pages/NotificationsAudit";
import Settings from "./pages/Settings";
import NotFound from "./auth/NotFound";

const local_server = 'http://localhost:3001';
const main_server = 'https://salon-admin.deyfreshsignature.com';
axios.defaults.baseURL = main_server; // Change to local_server for development
axios.defaults.withCredentials = true;

function App() {
  return (
    <AuthProvider> 
      <BrowserRouter>
        <Routes>

          <Route path="/" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={["super_admin", "manager", "cashier"]}>
                <AdminLayout>
                  <Dashboard />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

            <Route
            path="/booking"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout>
                  <Booking />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

             <Route
            path="/gallery"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout>
                  <Gallery />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

            <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={["super_admin"]}>
                <AdminLayout>
                  <AdminStaff />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/clients"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager","cashier"]}>
                <AdminLayout><Clients /></AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/services"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout><ServicesManagement /></AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/schedule"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout><Schedule /></AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/walk-in"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager","cashier"]}>
                <AdminLayout><WalkIn /></AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/expenses"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout><Expenses /></AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/reports"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout><Reports /></AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/notifications"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout><NotificationsAudit /></AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout><Settings /></AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/staff"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout>
                  <StaffList />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/attendance"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager"]}>
                <AdminLayout>
                  <Attendance />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/sales"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager", "cashier"]}>
                <AdminLayout>
                  <Sales />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/products"
            element={
              <ProtectedRoute allowedRoles={["super_admin","manager","cashier"]}>
                <AdminLayout>
                  <ProductList />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NotFound />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;